mutation CleanQueueMutation($queueName: String!, $status: String!) {
  cleanQueue(queueName: $queueName, status: $status) {
    id
    name
    jobCounts {
      waiting
      active
      completed
      failed
      delayed
    }
  }
}
